/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2020-10-15 16:33:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            shopcode:'',// 商户号
            devicenumber:'', //设备号
            devicekeyword:'',//设备号
            version:'V3.0'
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {
            shopcode:'',
            devicekeyword:''
        },//
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        //查询设备日志列表
        list(context, payload) {
            return D.select({
                ...payload
            })

        },

        //查询商户列表
        getShopList(context, payload) {
            return D.select({
                ...payload
            })
        },

        //查询商户设备列表
        getDevicenumList(context, payload) {
            return D.select({
                ...payload
            })
        },

        //修改部门
        pushCommand(context, payload) {
            return D.add({
                ...payload
            })
        },

        //查询设备日志列表
        listv3(context, payload) {
            return D.select({
                ...payload
            })

        },

        //查询商户列表
        getShopListv3(context, payload) {
            return D.select({
                ...payload
            })
        },

        //查询商户设备列表
        getDevicenumListv3(context, payload) {
            return D.select({
                ...payload
            })
        },

        //修改部门
        pushCommandv3(context, payload) {
            return D.add({
                ...payload
            })
        },


        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        shopcode:'',// 商户号
                        devicenumber:'', //设备号
                        devicekeyword:'',//设备号
                        version:'V3.0'
                    }
                }
            })
        },
    }
}